import * as React from 'react';

import { Label } from './label';

interface ReadOnlyFieldProps {
  label: string;
  children: React.ReactNode;
}

export function ReadOnlyField({ label, children }: ReadOnlyFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Label>{label}</Label>
      <div className="bg-grey-1 ring-grey-3 flex min-h-[41px] flex-wrap items-center gap-1 rounded p-2 ring-2 ring-inset">{children}</div>
    </div>
  );
}
